<template>
  <section class="document-form sme-container__info sme-container__info-document">
    <div class="box">
      <div class="table">
        <div class="th font-14" >Documents</div>
        <div
          v-if="formData.renewal_letter_insurer"
          class="form-item tr">
          <span>Renewal Letter（Insurer）</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.renewal_letter_insurer" />
        </div>
        <div class="form-item tr">
          <span>Policyholder HKID</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.id_type_pic" />
        </div>
        <div class="form-item tr">
          <span>Insured Student Details</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="{
              client_name:student_info.id_type_pic_path_id,
              thumb_url:student_info.id_type_pic_thumb_url,
              url:student_info.id_type_pic_url,
            }" />
        </div>
        <div
          v-if="hasAcc"
          class="form-item tr">
          <span>Accompanying Parent or Guardian Details</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="{
              client_name:acc_parent_info.id_type_pic_path_id,
              thumb_url:acc_parent_info.id_type_pic_thumb_url,
              url:acc_parent_info.id_type_pic_url,
            }" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'StudentDocumentInfo',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed:{
    hasAcc(){
      let {benefits = []} =  this.formData||{}
      return benefits.includes(2)
    },
    student_info(){
      let {student_info = {}} = this.formData
      return student_info||{}
    },
    acc_parent_info(){
      let {acc_parent_info = {}} = this.formData
      return acc_parent_info||{}
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

</style>
